import React from 'react';

export default function HeroSection({ onScheduleClick }) {
  return (
    <section id="home" className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-12 md:pt-16 pb-10">
      <div className="flex flex-col items-center text-center space-y-6 max-w-4xl mx-auto">
        {/* Executive Pill Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-surface-container-low/90 dark:bg-clinical-slate-800/90 backdrop-blur-xl border border-glass-border-light dark:border-gray-700 shadow-sm">
          <span className="w-2 h-2 rounded-full bg-accent-teal animate-pulse"></span>
          <span className="text-[11px] uppercase tracking-wider text-primary dark:text-primary-fixed font-bold">
            NFBG Scorpio Executive Advisory &amp; Healthcare Practice
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-3xl sm:text-5xl lg:text-6xl text-gray-900 dark:text-white font-extrabold tracking-tight leading-tight">
          Specialized Healthcare Mediation, Leadership Excellence &amp; Organizational Resilience
        </h1>

        {/* Subtitle */}
        <p className="text-base sm:text-lg lg:text-xl text-gray-600 dark:text-slate-300 max-w-2xl leading-relaxed">
          Transforming clinical conflict into operational alignment. Built specifically for Hospital Systems,
          Physician Groups, and Senior Healthcare Executives navigating critical inflection points.
        </p>

        {/* Primary CTAs */}
        <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
          <button
            type="button"
            onClick={onScheduleClick}
            className="inline-flex items-center justify-center gap-2.5 px-8 py-3.5 rounded-2xl bg-primary text-white font-bold text-base sm:text-lg shadow-[0_20px_40px_-12px_rgba(0,97,148,0.35)] hover:bg-primary-container hover:scale-105 active:scale-95 transition-all duration-300"
          >
            <span>Schedule Consultation</span>
            <span className="material-symbols-outlined text-[20px]">calendar_today</span>
          </button>

          <a
            href="#strategic-tiers"
            className="inline-flex items-center justify-center gap-2.5 px-8 py-3.5 rounded-2xl bg-white dark:bg-clinical-slate-800 text-gray-800 dark:text-slate-200 hover:text-primary hover:bg-gray-50 dark:hover:bg-clinical-slate-700 border border-gray-200 dark:border-gray-700 font-bold text-base sm:text-lg shadow-sm hover:shadow-md hover:scale-105 active:scale-95 transition-all duration-300"
          >
            <span>Explore Strategic Tiers</span>
            <span className="material-symbols-outlined text-[20px]">expand_more</span>
          </a>
        </div>
      </div>
    </section>
  );
}
